var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card border-0"},[_c('b-row',{staticClass:"heading-container"},[_c('h4',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm._f("startcase")(_vm.$t("manual_matching")))+" ")])]),_c('metadata-conflict-detail',{ref:"conflict",attrs:{"conflict":_vm.conflict,"standalone":true},on:{"matched":_vm.onMatched}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }